export default __webpack_public_path__ + "984f5cd98edbe4d34e9df0221489b46e.png";